import styled from '@emotion/styled'

// eslint-disable-next-line import/prefer-default-export
export const ErrorMessage = styled.p`
  color: #cb1a1a;
`
